// extracted by mini-css-extract-plugin
export default {"imgContainer":"LogoCarousel_imgContainer__vwfx0","logo":"LogoCarousel_logo__Lz-wL","carouselContainer":"LogoCarousel_carouselContainer__1M1gf"};